import { Appearance } from '@stripe/stripe-js';

import { CalmTheme } from '@calm-web/design-system';

const { palette } = CalmTheme;

// Shared by the `borderRadius` variable and the pinned accordion item so the items keep the rounded look.
const BORDER_RADIUS = '36px';

// Pinned accordion-item look. Stripe's Payment Element applies these to its own items and the
// Truemed row (TruemedCheckout/styles.tsx) reads the same constants, so the two cannot drift.
export const ACCORDION_ITEM_SPACING = '8px';
export const ACCORDION_ITEM = {
	backgroundColor: palette.white,
	border: `1px solid ${palette.gray2}`,
	borderRadius: BORDER_RADIUS,
	boxShadow: '0 1px 1px rgba(0, 0, 0, 0.03), 0 3px 6px rgba(18, 42, 66, 0.02)',
	padding: '16px',
} as const;
// Stripe derives its secondary text color from `colorText`; it has no palette equivalent (gray5 is
// close but not identical), so it is named here for the notice and fine print under a method.
export const ACCORDION_SECONDARY_TEXT_COLOR = '#747474';
export const ACCORDION_FOCUS_RING = '0 0 0 3px rgba(26, 62, 112, 0.25)';
export const ACCORDION_ITEM_LABEL = {
	color: palette.gray6,
	selectedColor: palette.buttonBlue,
	fontSize: '16px',
	fontWeight: '500',
} as const;

export const stripeAppearanceOptions: Appearance = {
	labels: 'floating',
	variables: {
		fontFamily: 'Figtree, Arial',
		colorPrimary: CalmTheme.palette.buttonBlue,
		colorText: CalmTheme.palette.gray7,
		colorDanger: CalmTheme.palette.errorRed,
		borderRadius: BORDER_RADIUS,
		accordionItemSpacing: ACCORDION_ITEM_SPACING,
		accordionItemLabelColorText: ACCORDION_ITEM_LABEL.color,
		accordionItemLabelSelectedColorText: ACCORDION_ITEM_LABEL.selectedColor,
		accordionItemLabelFontSize: ACCORDION_ITEM_LABEL.fontSize,
		accordionItemLabelFontWeight: ACCORDION_ITEM_LABEL.fontWeight,
		accordionItemLabelSelectedFontWeight: ACCORDION_ITEM_LABEL.fontWeight,
	},
	rules: {
		'.AccordionItem': { ...ACCORDION_ITEM },
		'.AccordionItem--selected': {
			border: ACCORDION_ITEM.border,
			boxShadow: ACCORDION_ITEM.boxShadow,
		},
		'.Tab': {
			borderRadius: '6px',
		},
		'.Label': {
			color: CalmTheme.palette.gray5,
			fontWeight: '500',
		},
		'.Input': {
			border: `2px ${CalmTheme.palette.gray2} solid`,
			borderRadius: '6px',
			color: CalmTheme.palette.gray5,
			fontWeight: '500',
		},
		'.Error': {
			fontSize: '0.75rem',
			fontWeight: '500',
			padding: '4px 1px 0 0',
		},
	},
};

export const desktopStripeAppearanceOptions: Appearance = {
	...stripeAppearanceOptions,
	rules: {
		...stripeAppearanceOptions.rules,
		'.Error': {
			fontSize: `${0.75 * 1.125}rem`,
			fontWeight: '500',
			padding: '4px 1px 0 0',
		},
	},
};
